import type { Motif, PartialMotifStyles } from '@snapchat/snap-design-system-marketing';
import {
  defaultMotif,
  m,
  mergeMotifs,
  MotifComponent,
  MotifScheme,
} from '@snapchat/snap-design-system-marketing';

// ghost button style under bright-color background (yellow, white, gray)
const ghostStyleUnderBrightBackground: PartialMotifStyles[MotifComponent.BUTTON] = {
  '--button-secondary-bg-color': m('--palette-plain-transparent'), // transparent background
  '--button-secondary-hover-bg-color': m('--palette-plain-transparent'), // transparent background
  '--button-secondary-border-color': m('--block-title-de-emphasized-color'), // keeping this to get a sense of what it looks like maybe
  '--button-secondary-hover-border-color': m('--block-title-de-emphasized-color'),
  '--button-secondary-fg-color': m('--palette-black-v200'),
} as const;

// ghost button style under dark-color background (black)
const ghostStyleUnderDarkBackground: PartialMotifStyles[MotifComponent.BUTTON] = {
  '--button-secondary-bg-color': m('--palette-plain-transparent'), // transparent background
  '--button-secondary-hover-bg-color': m('--palette-plain-transparent'), // transparent background
  '--button-secondary-border-color': m('--block-title-de-emphasized-color'), // keeping this to get a sense of what it looks like maybe
  '--button-secondary-hover-border-color': m('--block-title-de-emphasized-color'),
  '--button-secondary-fg-color': m('--palette-plain-white'),
} as const;

export const ghostMotif: Motif = mergeMotifs(defaultMotif, {
  name: 'Ghost motif',
  [MotifScheme.SECONDARY]: {
    name: 'Ghost button style for secondary buttons under secondary background',
    [MotifComponent.BUTTON]: ghostStyleUnderDarkBackground,
  },
  [MotifScheme.DEFAULT]: {
    name: 'Ghost button style for secondary buttons under default background',
    [MotifComponent.BUTTON]: ghostStyleUnderBrightBackground,
  },
  [MotifScheme.TERTIARY]: {
    name: 'Ghost button style for secondary buttons under tertiary background',
    [MotifComponent.BUTTON]: ghostStyleUnderBrightBackground,
  },
  [MotifScheme.QUATERNARY]: {
    name: 'Ghost button style for secondary buttons under quaternary background',
    [MotifComponent.BUTTON]: ghostStyleUnderBrightBackground,
  },
});
